import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { OrganizationSetupCommon } from 'src/app/organization-setup/organization-setup.common';
import { CommonMessageService } from 'src/app/services/common-message.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { OrganizationSetupService } from 'src/app/services/organization-setup.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-article-vacancy',
  templateUrl: './article-vacancy.component.html',
  styleUrls: ['./article-vacancy.component.css']
})
export class ArticleVacancyComponent implements OnInit {
  partnerList;
  modalStatus:any;
  modalForm:any;
  formSubmitted = false;
  formErrors = OrganizationSetupCommon.artcleVacancyFormErrors;
  formValidationMessages = OrganizationSetupCommon.artcleVacancyFormValidationMessages;
  partnerId;
  articleVacancyData=[];

  constructor(private modalService: NgbModal,private fb: FormBuilder,private organizationSetupService: OrganizationSetupService,
    private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.initModalForm();
    this.getPartnerList();
    this.getVaccancyDetails();
    // this.modalForm.valueChanges.subscribe((data) => {
    //   this.logValidationErrors(this.modalForm);
    // });
  }

  getPartnerList(){
   this.organizationSetupService.getPartnerListDetails().subscribe((resp:any)=>{
    console.log('partnerList',resp);
    this.partnerList=resp;
   });
  }

  getVaccancyDetails(){
    this.organizationSetupService.getArticleVacancyDetails().subscribe((resp:any)=>{
      console.log('getvacancyresp',resp)
      this.articleVacancyData=resp;
    })
  }

  initModalForm() {
    this.modalForm = this.fb.group({
      id: [''],
      partnerName: ['', [Validators.required]],
      articleEligibility: ['', [Validators.required]],
    });
  }
  
  onSaveClick(){
    console.log('modalform value',this.modalForm)
  
    this.formSubmitted = true;
    this.logValidationErrors(this.modalForm);
    var body={
      "id": null,
      "partner": {
          "id": this.modalForm.value.partnerName.id
      },
      "eligibility": this.modalForm.value.articleEligibility
     }
      console.log('json of save',body)
    if (this.modalForm.valid) {
    this.organizationSetupService.saveArticleVacancyDetails(body).subscribe((resp:any)=>{
      console.log('vacancy details',resp)
      this.getVaccancyDetails();
      this.closeModal();
      this.commonMessageService.swalAlertWithIcon('','Saved Successfully!','success');
    });
  }
}

onEditClick(content,item){
  this.modalStatus=item;
  this.openModal(content,'edit');
  this.setValueToModalForm(item);
}


setValueToModalForm(modalObj){
  console.log('setvalue to modal',modalObj);
  const partnerId=this.partnerList.findIndex(item => item.id == modalObj.partner.id);
  this.modalForm.patchValue({
    id:modalObj.id,
    partnerName:this.partnerList[partnerId],
    articleEligibility: modalObj.eligibility,
  });
}

onDeleteClick(item){
console.log(' delete data',item);
Swal.fire({
  text: 'Are you sure you want to remove?',
  showCancelButton: true,
  confirmButtonText: 'Ok',
  confirmButtonColor:'#800000'
}).then((result) => {
  if (result.isConfirmed) {
   this.modalStatus = 'delete';
   this.organizationSetupService.deleteArticleVacancyDetails(item.id)
   .subscribe(resp => {
    console.log(resp);
    this.getVaccancyDetails();
    this.commonMessageService.swalAlertWithIcon('','Deleted Successfully!','success');
  })
  }
})
}

  onUpdateClick(){
    var body={
      "id": this.modalForm.value.id,
      "partner": {
          "id": this.modalForm.value.partnerName.id
      },
      "eligibility": this.modalForm.value.articleEligibility
     }
  console.log('json of update',body)
      this.formSubmitted = true;
      this.logValidationErrors(this.modalForm);
      if (this.modalForm.valid) {
      this.organizationSetupService.updateArticleVacancyDetails(body).subscribe((resp:any)=>{
        console.log('vacancy details',resp)
        this.getVaccancyDetails();
        this.closeModal();
        this.commonMessageService.swalAlertWithIcon('','Updated Successfully!','success');
      });
    }
  }

  openModal(content, status) {
    this.modalStatus = status;
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'md', backdrop: 'static', windowClass: "animate__animated animate__slideInUp animate__faster" }).result.then((result) => {
    }, (reason) => {
    });
  }

  closeModal() {
    this.modalForm.reset();
    this.modalService.dismissAll();
  }

  
  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        // console.log('Key = ' + key + ' && Value = ' + abstractControl.value);
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.formSubmitted) {
          const messages = this.formValidationMessages[key];
          for (const errorKey in abstractControl.errors) {
            console.log(errorKey)
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }
}
